var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYahoo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Yahoo/Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 5.24716H3.95308L6.24788 11.1473L8.57617 5.24716H12.4288L6.63313 19.2328H2.76381L4.35509 15.5346L0 5.24716ZM13.0151 10.8448C14.3384 10.8448 15.4104 11.9206 15.4104 13.2485C15.4104 14.5765 14.3384 15.6523 13.0151 15.6523C11.6918 15.6523 10.6198 14.5765 10.6198 13.2485C10.6198 11.9206 11.6918 10.8448 13.0151 10.8448ZM16.1977 9.97066H11.8928L15.7119 0.742188H20L16.1977 9.97066Z",
    fill: "#5F01D1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahoo);
export default __webpack_public_path__ + "static/media/yahoo.ea0382a1381953555182c57f5f1e5004.svg";
export { ForwardRef as ReactComponent };